import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const Showcase = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1.08, 1]);

  return (
    <section ref={ref} className="mx-auto max-w-6xl px-5 py-24" data-testid="showcase">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Real conversations</span>
          <h2 className="mt-4 font-display text-4xl font-black tracking-tighter text-charcoal sm:text-5xl">
            It feels human. It scales like software.
          </h2>
          <p className="mt-5 text-base leading-relaxed text-silver-700 sm:text-lg">
            Your customers just chat on WhatsApp like they always do. Behind the scenes, the AI reads
            intent, scores the lead, and routes the winners to your team, thousands of conversations at once.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-6">
            {[
              ["<5s", "avg. first reply"],
              ["24/7", "always on"],
              ["70%", "less telecaller load"],
              ["3.2x", "more booked demos"],
            ].map(([v, l]) => (
              <div key={l}>
                <p className="font-display text-3xl font-black tracking-tighter text-charcoal">{v}</p>
                <p className="text-sm text-silver-500">{l}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div
            className="relative overflow-hidden rounded-[2rem] border border-silver-300/60 shadow-[0_30px_80px_rgb(0,0,0,0.10)]"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% 92%, 0 100%)" }}
          >
            <motion.img
              style={{ y, scale }}
              src="https://images.pexels.com/photos/12912010/pexels-photo-12912010.jpeg"
              alt="Business owner chatting with AI agent on phone"
              className="h-[460px] w-full object-cover"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-charcoal/40 via-transparent to-transparent" />
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="absolute bottom-8 left-6 rounded-2xl border border-white/20 bg-white/85 px-5 py-4 backdrop-blur-md"
            >
              <p className="text-xs font-bold uppercase tracking-widest text-brand-dark">Lead qualified</p>
              <p className="font-display text-lg font-extrabold text-charcoal">Hot · Score 88/100</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Showcase;
